import { signImageUpload } from 'utils/apis';
import { ResourceGroup } from 'types/schema';

export const handleUploadFile = async (file: any, resourceGroup: ResourceGroup) => {
  if (!file) {
    return new Error('File is required');
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = async () => {
      try {
        const response = await signImageUpload({
          resourceGroup: resourceGroup,
          contentType: file.type,
          fileName: file.name,
        });

        if (!response?.success) {
          return reject({ error: 'Failed to sign image upload!' });
        }

        const { uploadUrl, fullUrl } = response;

        if (!reader.result) {
          return reject({ error: "Can't read file content!" });
        }

        const fileContent = new Blob([reader.result], { type: file.type });

        try {
          await fetch(uploadUrl, {
            method: 'PUT',
            mode: 'cors',
            body: fileContent,
          });
          resolve({ uploadUrl, fullUrl, name: file.name, type: file.type });
        } catch (uploadError) {
          reject({ error: 'Error uploading file!' });
        }
      } catch (signError) {
        reject({ error: 'Error signing upload request!' });
      }
    };

    reader.onerror = () => {
      reject({ error: 'Error reading file!' });
    };

    reader.readAsArrayBuffer(file);
  });
};
